// Lazy load function
const lazyLoad = (file) => () =>
    import(
      /* webpackChunkName: "[request]" */ `@/views/products/batch/${file}.vue`
    );

export default [

    {
        path: "/batch-details",
        name: "batch-details",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProductBatchManagement",
        },
        components: {
            content: lazyLoad('batch-details-list'),
        },
    },
];
